import React from "react";
import { Card } from "antd";

const UICard = ({
  children,
  style = {},
  className = {},
  clickAble = false,
  onClick = () => {},
}) => {
  return (
    <Card
      onClick={onClick}
      className={className}
      style={{ cursor: clickAble ? "pointer" : "", ...style }}
    >
      {children}
      <div className="clearfix"></div>
    </Card>
  );
};

export default UICard;
